document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("custom-form");
  const calendarElement = document.getElementById("calendario");
  const timeSlotsContainer = document.querySelector(".time-slots");
  const selectedTimeInput = document.getElementById("selected_time_slot");
  const selectedDateTimeInput = document.getElementById("selected_datetime");
  const statusMsg = document.getElementById("form-status");
  const selectionStatus = document.getElementById("appointment-selection-status");
  const containerMessagge = document.querySelector(".form-container-messagge");
  const contactForm = document.querySelector(".form-container");

  if (
    !form ||
    !calendarElement ||
    !timeSlotsContainer ||
    !selectedTimeInput ||
    !selectedDateTimeInput
  ) {
    return;
  }

  let fp;
  let selectedDateLabel = "";
  const fields = Array.from(
    form.querySelectorAll("input:not([type='hidden']), textarea")
  );
  const requiredFields = fields.filter((field) => field.hasAttribute("required"));

  function getErrorElement(field) {
    const errorId = field.getAttribute("aria-describedby");
    return errorId ? document.getElementById(errorId) : null;
  }

  function setFieldError(field, message) {
    const errorElement = getErrorElement(field);

    field.setAttribute("aria-invalid", "true");
    field.setCustomValidity(message);
    field.closest(".appointment-field")?.classList.add("has-error");
    if (errorElement) errorElement.textContent = message;
  }

  function clearFieldError(field) {
    const errorElement = getErrorElement(field);

    field.removeAttribute("aria-invalid");
    field.setCustomValidity("");
    field.closest(".appointment-field")?.classList.remove("has-error");
    if (errorElement) errorElement.textContent = "";
  }

  function validateField(field) {
    const value = field.value.trim();

    if (field.hasAttribute("required") && value === "") {
      setFieldError(field, field.dataset.requiredMessage || "This field is required.");
      return false;
    }

    if (field.type === "email" && value !== "" && field.validity.typeMismatch) {
      setFieldError(field, field.dataset.typeMessage || "Enter a valid email address.");
      return false;
    }

    clearFieldError(field);
    return true;
  }

  function validatePersonalDetails() {
    let firstInvalidField = null;

    requiredFields.forEach((field) => {
      if (!validateField(field) && !firstInvalidField) {
        firstInvalidField = field;
      }
    });

    return firstInvalidField;
  }

  const weekdayTimes = [
    "6:00 AM",
    "7:00 AM",
    "8:00 AM",
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
  ];
  const weekendTimes = [
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
  ];

  function formatSelectedDate(date) {
    if (!date) return "";

    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  function updateSelectionStatus() {
    if (!selectionStatus) return;

    if (selectedDateLabel && selectedTimeInput.value) {
      selectionStatus.textContent = `Selected appointment: ${selectedDateLabel} at ${selectedTimeInput.value}.`;
    } else if (selectedDateLabel) {
      selectionStatus.textContent = `Selected date: ${selectedDateLabel}. Select an appointment time.`;
    } else if (selectedTimeInput.value) {
      selectionStatus.textContent = `Selected time: ${selectedTimeInput.value}. Select an appointment date.`;
    } else {
      selectionStatus.textContent = "No appointment date or time selected.";
    }
  }

  function updateCalendarAccessibility() {
    if (!fp?.calendarContainer) return;

    const dayElements = Array.from(
      fp.calendarContainer.querySelectorAll(".flatpickr-day")
    );
    const enabledDays = dayElements.filter(
      (dayElement) => !dayElement.classList.contains("flatpickr-disabled")
    );
    const selectedDay = enabledDays.find((dayElement) =>
      dayElement.classList.contains("selected")
    );
    const today = enabledDays.find((dayElement) =>
      dayElement.classList.contains("today")
    );
    const tabStop = selectedDay || today || enabledDays[0];

    fp.calendarContainer.setAttribute("role", "group");
    fp.calendarContainer.setAttribute("aria-label", "Appointment date picker");

    dayElements.forEach((dayElement) => {
      const isSelected = dayElement.classList.contains("selected");
      const isDisabled = dayElement.classList.contains("flatpickr-disabled");
      const dateLabel = dayElement.dateObj
        ? formatSelectedDate(dayElement.dateObj)
        : dayElement.getAttribute("aria-label") || dayElement.textContent.trim();

      dayElement.setAttribute("role", "button");
      dayElement.setAttribute("aria-selected", isSelected ? "true" : "false");
      dayElement.setAttribute("aria-disabled", isDisabled ? "true" : "false");
      dayElement.setAttribute("tabindex", dayElement === tabStop ? "0" : "-1");
      dayElement.setAttribute(
        "aria-label",
        isSelected ? `${dateLabel}, selected` : dateLabel
      );

      if (dayElement.classList.contains("today")) {
        dayElement.setAttribute("aria-current", "date");
      } else {
        dayElement.removeAttribute("aria-current");
      }
    });
  }

  function getEnabledCalendarDays() {
    if (!fp?.calendarContainer) return [];

    return Array.from(fp.calendarContainer.querySelectorAll(".flatpickr-day")).filter(
      (dayElement) => !dayElement.classList.contains("flatpickr-disabled")
    );
  }

  function focusCalendarDay(dayElement) {
    if (!dayElement) return;

    getEnabledCalendarDays().forEach((enabledDay) => {
      enabledDay.setAttribute("tabindex", enabledDay === dayElement ? "0" : "-1");
    });
    dayElement.focus();
  }

  function focusAdjacentCalendarDay(currentDay, direction) {
    const enabledDays = getEnabledCalendarDays();
    const currentIndex = enabledDays.indexOf(currentDay);
    if (currentIndex === -1) return;

    const nextIndex = Math.min(
      Math.max(currentIndex + direction, 0),
      enabledDays.length - 1
    );
    focusCalendarDay(enabledDays[nextIndex]);
  }

  function setSelectedTime(button) {
    timeSlotsContainer.querySelectorAll("button").forEach((timeButton) => {
      const isSelected = timeButton === button;
      timeButton.classList.toggle("active", isSelected);
      timeButton.setAttribute("aria-checked", isSelected ? "true" : "false");
      timeButton.setAttribute("tabindex", isSelected ? "0" : "-1");
    });

    selectedTimeInput.value = button.textContent.trim();
    updateSelectionStatus();
  }

  function focusAdjacentTimeButton(currentButton, direction) {
    const buttons = Array.from(timeSlotsContainer.querySelectorAll("button"));
    const currentIndex = buttons.indexOf(currentButton);
    if (currentIndex === -1) return;

    const nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
    buttons[nextIndex].focus();
  }

  function renderTimeSlots(isWeekend) {
    const timeRange = isWeekend ? weekendTimes : weekdayTimes;
    timeSlotsContainer.innerHTML = "";

    timeRange.forEach((time, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.textContent = time;
      button.setAttribute("role", "radio");
      button.setAttribute("aria-checked", "false");
      button.setAttribute("tabindex", index === 0 ? "0" : "-1");
      button.setAttribute("aria-label", `${time} Pacific Time`);

      button.addEventListener("click", function () {
        setSelectedTime(button);
      });

      button.addEventListener("keydown", function (event) {
        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          event.preventDefault();
          focusAdjacentTimeButton(button, 1);
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          event.preventDefault();
          focusAdjacentTimeButton(button, -1);
        } else if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          setSelectedTime(button);
        }
      });

      timeSlotsContainer.appendChild(button);
    });
  }

  fp = flatpickr(calendarElement, {
    noCalendar: false,
    enableTime: false,
    dateFormat: "Y-m-d",
    ariaDateFormat: "l, F j, Y",
    inline: true,
    locale: "en",
    minDate: "today",
    onReady: updateCalendarAccessibility,
    onMonthChange: updateCalendarAccessibility,
    onYearChange: updateCalendarAccessibility,
    onChange: function (selectedDates) {
      const selectedDate = selectedDates[0];
      const day = selectedDate?.getDay();
      const isWeekend = day === 0 || day === 6;

      selectedDateLabel = formatSelectedDate(selectedDate);
      selectedTimeInput.value = "";
      renderTimeSlots(isWeekend);
      updateSelectionStatus();
      updateCalendarAccessibility();
    },
  });

  (fp.calendarContainer || calendarElement).addEventListener("keydown", function (event) {
    const currentDay = event.target.closest(".flatpickr-day");
    if (!currentDay || currentDay.classList.contains("flatpickr-disabled")) return;

    if (event.key === "ArrowRight") {
      event.preventDefault();
      focusAdjacentCalendarDay(currentDay, 1);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      focusAdjacentCalendarDay(currentDay, -1);
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      focusAdjacentCalendarDay(currentDay, 7);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      focusAdjacentCalendarDay(currentDay, -7);
    } else if (event.key === "Home") {
      event.preventDefault();
      focusCalendarDay(getEnabledCalendarDays()[0]);
    } else if (event.key === "End") {
      event.preventDefault();
      const enabledDays = getEnabledCalendarDays();
      focusCalendarDay(enabledDays[enabledDays.length - 1]);
    } else if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      currentDay.click();
      updateCalendarAccessibility();
      focusCalendarDay(
        fp.calendarContainer.querySelector(".flatpickr-day.selected") || currentDay
      );
    }
  });

  const today = new Date();
  renderTimeSlots(today.getDay() === 0 || today.getDay() === 6);
  updateSelectionStatus();
  updateCalendarAccessibility();

  fields.forEach((field) => {
    field.addEventListener("input", () => validateField(field));
    field.addEventListener("blur", () => validateField(field));
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const firstInvalidField = validatePersonalDetails();
    const selectedDate = fp.selectedDates[0];
    const selectedTime = selectedTimeInput.value;
    const submitButton = form.querySelector('button[type="submit"]');

    if (firstInvalidField) {
      if (containerMessagge) containerMessagge.style.display = "block";
      statusMsg.textContent =
        firstInvalidField.validationMessage ||
        "Please correct the highlighted field.";
      firstInvalidField.focus();
      return;
    }

    if (!selectedDate) {
      if (containerMessagge) containerMessagge.style.display = "block";
      statusMsg.textContent = "Please select a date.";
      focusCalendarDay(getEnabledCalendarDays()[0]);
      return;
    }

    if (!selectedTime) {
      if (containerMessagge) containerMessagge.style.display = "block";
      statusMsg.textContent = "Please select a time.";
      timeSlotsContainer.querySelector("button")?.focus();
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Sending...";

    const datePart = fp.formatDate(selectedDate, "Y-m-d");
    const dateTimeCombined = `${datePart} ${selectedTime}`;
    selectedDateTimeInput.value = dateTimeCombined;

    const formData = new FormData(form);

    fetch("https://formsubmit.co/ajax/shopfourseasons@sobelwestex.com", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          statusMsg.textContent =
            "Thank you for filling out the form! We have received your information successfully.";
          form.reset();
          fp.clear();
          selectedDateLabel = "";
          selectedTimeInput.value = "";
          selectedDateTimeInput.value = "";
          renderTimeSlots(false);
          updateSelectionStatus();
          updateCalendarAccessibility();
          containerMessagge.style.display = "block";
          contactForm.style.display = "none";
        } else {
          return response.json().then((data) => {
            throw new Error(data.message || "Something went wrong");
          });
        }
      })
      .catch((error) => {
        statusMsg.textContent = "Error sending form. Please try again.";
        console.error("Form error:", error);
      });
  });
});
